import { fontSize } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { breakpoint } from 'src/styles/dontgiftguide.styles';
import { dggTheme } from '../../../../styles/dggTheme';
import { doubleSnowflakeURL } from '../../levelOne/SectionGroup/SectionGroup.styles';

const { spacing, fonts, text } = dggTheme;

const headingFontSize = { mobile: 46, default: 80 };

export const root = css`
  text-align: center;
`;

export const title = css`
  padding: ${pxToRem(spacing.sm)} 0;
  margin: 0;
  ${fontSize(text.HEADING.SM)}
  font-family: ${fonts.PRIMARY_SEMIBOLD.familyWithFallbacks};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};

  ${mediaQuery(
    { min: breakpoint },
    css`
      ${fontSize(text.HEADING.XL)}
      padding: ${pxToRem(spacing.xxl)} 0;
    `,
  )}
}
`;

export const heading = css`
  font-size: ${pxToRem(headingFontSize.mobile)};
  line-height: ${pxToRem(headingFontSize.mobile)};
  margin: ${pxToRem(spacing.xs)} 0;
  font-family: ${fonts.PRIMARY_SEMIBOLD.familyWithFallbacks};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  background-image: url(${doubleSnowflakeURL});
  background-repeat: no-repeat;
  background-position: right bottom;
  background-size: ${pxToRem(50)};

  ${mediaQuery(
    { min: breakpoint },
    css`
      width: ${pxToRem(540)};
      margin: ${pxToRem(spacing.xs)} auto;
      font-size: ${pxToRem(headingFontSize.default)};
      line-height: ${pxToRem(headingFontSize.default)};
      font-family: ${fonts.PRIMARY_REGULAR.familyWithFallbacks};
      font-weight: ${fonts.PRIMARY_REGULAR.weight};
      background-size: ${pxToRem(80)};
      background-position: right ${pxToRem(10)} bottom;
    `,
  )}
`;

export const copy = css`
  margin: 0;
  font-size: ${pxToRem(text.HEADING.XS.fontSize)};
  margin: ${pxToRem(spacing.md)} 0;

  ${mediaQuery(
    { min: breakpoint },
    css`
      width: ${pxToRem(650)};
      margin: ${pxToRem(spacing.xxl)} auto;
      font-size: ${pxToRem(text.HEADING.MD.fontSize)};
    `,
  )}
`;
